import airhorn from "../assets/sounds/airhorn.wav";
import applause from "../assets/sounds/applause.wav";
import brrrap from "../assets/sounds/brrrap.wav";
import honk from "../assets/sounds/honk.wav";
import inception from "../assets/sounds/inception.mp3";
import orgasm from "../assets/sounds/orgasm.wav";
import rastafari from "../assets/sounds/rastafari.wav";
import mario1 from "../assets/sounds/sm64_mario_burned.wav";
import mario2 from "../assets/sounds/sm64_mario_here_we_go.wav";
import mario3 from "../assets/sounds/sm64_mario_lets_go.wav";
import yoshi1 from "../assets/sounds/sm64_yoshi.wav";
import yoshi2 from "../assets/sounds/smsunshine_yoshi_out_of_juice.wav";
import yoshi3 from "../assets/sounds/smsunshine_yoshi_tongue_grab.wav";
import whistle from "../assets/sounds/whistle.wav";
import wilhelm from "../assets/sounds/wilhelm.wav";
import yeah from "../assets/sounds/yeah.wav";

export default {
  honk: {
    sound: [honk],
  },
  applause: {
    sound: [applause],
  },
  orgasm: {
    sound: [orgasm],
  },
  whistle: {
    sound: [whistle],
  },
  yeah: {
    sound: [yeah],
  },
  wilhelm: {
    sound: [wilhelm],
  },
  airhorn: {
    sound: [airhorn],
  },
  brrrap: {
    sound: [brrrap],
  },
  rastafari: {
    sound: [rastafari],
  },
  inception: {
    sound: [inception],
  },
  mario1: {
    sound: [mario1],
  },
  mario2: {
    sound: [mario2],
  },
  mario3: {
    sound: [mario3],
  },
  yoshi1: {
    sound: [yoshi1],
  },
  yoshi2: {
    sound: [yoshi2],
  },
  yoshi3: {
    sound: [yoshi3],
  },
};
